<template>
    <div class="container">
        <div id="myTabContent" class="tab-content">
            <list id="newest" list-field="latest_list" class="in active"></list>
            <list id="popular" list-field="hot_list"></list>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Page",
        created() {
            console.log('list','init')
        },
        watch:{
            '$route':function ($route) {
                console.log($route)
            }
        }
    }
</script>

<style scoped>

</style>